// This file is automatically generated. Do not edit it directly.
import { createClient } from "@supabase/supabase-js";

/**
 * 环境变量类型声明
 */
declare global {
  interface ImportMeta {
    env: {
      SUPABASE_URL?: string;
      SUPABASE_PUBLISHABLE_KEY?: string;
      VITE_SUPABASE_URL?: string;
      VITE_SUPABASE_PUBLISHABLE_KEY?: string;
      VITE_DEV_MODE?: string;
      MODE?: string;
      DEV?: boolean;
    }
  }
}

/**
 * 检查是否处于开发模式
 */
const isDevelopmentMode = import.meta.env.DEV || 
  import.meta.env.MODE === 'development' || 
  import.meta.env.VITE_DEV_MODE === 'true';

/**
 * 从环境变量安全获取配置
 * 优先使用VITE_前缀的环境变量（Vite默认暴露给客户端），然后是无前缀变量
 */
const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL || 
  import.meta.env.SUPABASE_URL || '';

const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY || 
  import.meta.env.SUPABASE_PUBLISHABLE_KEY || '';

// 仅在开发模式下打印连接状态
if (isDevelopmentMode) {
  console.log('Supabase配置状态:', {
    url: SUPABASE_URL ? '已配置' : '未配置',
    key: SUPABASE_ANON_KEY ? '已配置' : '未配置',
    mode: isDevelopmentMode ? '开发模式' : '生产模式'
  });
}

/**
 * 创建Supabase客户端
 * 
 * 配置信息应通过环境变量提供:
 * 1. 本地开发: .env.local 文件
 * 2. 部署环境: 环境变量或构建时注入
 */
export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

/**
 * 检查Supabase配置是否有效
 * 仅供调试使用，生产环境中请勿调用
 */
export const checkSupabaseConfig = () => {
  return {
    hasUrl: Boolean(SUPABASE_URL),
    hasKey: Boolean(SUPABASE_ANON_KEY),
    isDevelopment: isDevelopmentMode
  };
};